// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609111313/js/" + chunkId + "." + {"44":"5072272d","225":"dbc5a288","481":"89d25c14","486":"895f4ed2","770":"4a2470ee"}[chunkId] + ".0.495336683334367.chunk.js";
};